import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import PlatformSidebar from '../components/layout/PlatformSidebar';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

export default function PlatformLayout() {
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <PlatformSidebar />

      <Box sx={{ flexGrow: 1, minHeight: '100vh', display: 'flex', flexDirection: 'column', bgcolor: 'background.default' }}>
        <Header />

        <Box sx={{ flexGrow: 1, maxWidth: 1280, width: '100%', mx: 'auto', px: { xs: 2.5, md: 4 }, py: { xs: 3, md: 4 } }}>
          <Outlet />
        </Box>

        <Footer />
      </Box>
    </Box>
  );
}
